import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import GroupsCarousel from '../../book/right-panel/GroupsCarousel';
import MultipleSelectionButton from '../../book/right-panel/MultipleSelectionButton';

export default class PanelChoosingCarousel extends React.Component {
  static propTypes = {
    mode: PropTypes.string,
    selectedGroup: PropTypes.object,
    openChooseMultiple: PropTypes.func,
    students: PropTypes.array,
    label: PropTypes.string,
    groups: PropTypes.array,
    setSelectedGroup: PropTypes.func
  };

  getMultipleButton = () => {
    const { mode, selectedGroup, openChooseMultiple, groups } = this.props;
    return (
      <div className="choose-students-container">
        {groups && groups.length ? <div className="group-circles-separator"> {I18n.t('common.or')} </div> : ''}
        <MultipleSelectionButton currentSelection={selectedGroup} openChooseMultiple={openChooseMultiple} mode={mode} />
      </div>
    );
  };

  render() {
    const { label, selectedGroup, groups, setSelectedGroup } = this.props;

    return (
      <Fragment>
        <span className="section-title-label">{label}</span>
        <div className="students-groups-container panel">
          <GroupsCarousel
            currentSelection={selectedGroup}
            hasMultipleChoose={true}
            groups={groups}
            selectGroup={setSelectedGroup}
          />
          {this.getMultipleButton()}
        </div>
      </Fragment>
    );
  }
}
